/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ActivateSignatureSignerDto = {
  /**
   * UUID of signer
   */
  id: string;
  /**
   * Status of the signer
   */
  status: ActivateSignatureSignerDto.status;
  /**
   * Signature link URI
   */
  signature_link: string | null;
  /**
   * Signature link expiration date
   */
  signature_link_expiration_date: string | null;
};
export namespace ActivateSignatureSignerDto {
  /**
   * Status of the signer
   */
  export enum status {
    ABORTED = 'aborted',
    CONSENT_GIVEN = 'consent_given',
    DECLINED = 'declined',
    ERROR = 'error',
    INITIATED = 'initiated',
    NOTIFIED = 'notified',
    PROCESSING = 'processing',
    SIGNED = 'signed',
    VERIFIED = 'verified',
  }
}
